export default __webpack_public_path__ + "static/media/CSRealCase1.7ba691fa.jpg";